module.exports = __webpack_public_path__ + "static/media/um.c9446ffe.svg";